import { formatEuro, formatInteger } from '@brimo/shared';

/** Texts of the deals module that the screens derive from figures („9 T", „2,1 Mio", „41 Deals · 14,3 Mio € KP"). */

const oneDecimal = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/** „9 T" — days in the current stage. */
export function ageText(days: number): string {
  return `${formatInteger(days)}\u00a0T`;
}

/** Column sums of the board: „2,1 Mio" from 1 Mio €, „787 T" below, „—" for nothing. */
export function shortSum(cents: number | null): string {
  if (cents === null) return 'ausgeblendet';
  if (cents <= 0) return '—';
  const euros = cents / 100;
  if (euros >= 1_000_000) return `${oneDecimal.format(euros / 1_000_000)}\u00a0Mio`;
  return `${formatInteger(Math.round(euros / 1000))}\u00a0T`;
}

/** „14,3 Mio €" from 1 Mio €, else the full amount („498.000 €", „0 €") — the sum for the head line. */
export function sumWithEuro(cents: number | null): string {
  if (cents === null) return 'Summen ausgeblendet';
  if (cents <= 0) return formatEuro(0);
  const euros = cents / 100;
  if (euros >= 1_000_000) return `${oneDecimal.format(euros / 1_000_000)}\u00a0Mio\u00a0€`;
  return formatEuro(cents);
}

export function dealsCount(count: number): string {
  return count === 1 ? '1 Deal' : `${formatInteger(count)} Deals`;
}

/** The card value: „340.000 €", or the mask text when the server hides it. */
export function cardValue(cents: number | null, masked: boolean, maskText: string): string {
  if (masked || cents === null) return masked ? maskText : '—';
  return formatEuro(cents);
}

/** „2026-09-24" → „24.09." */
export function shortDayOf(key: string): string {
  const [, month = '', day = ''] = key.split('-');
  return `${day}.${month}.`;
}
